import axios from 'axios';
import { performLogout } from '../utils/logout';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

// Función para verificar si el token JWT está expirado
const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    // Decodificar el payload del JWT (segunda parte del token)
    const payload = JSON.parse(atob(token.split('.')[1]));

    // Verificar si tiene campo exp (expiration time en segundos desde epoch)
    if (!payload.exp) return false;

    // Comparar con el tiempo actual (en segundos)
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
  } catch (error) {
    // Si hay error al decodificar, considerar el token como inválido/expirado
    console.error('Error al decodificar token:', error);
    return true;
  }
};

axios.interceptors.request.use(request => {
  if (!window.sessionStorage.getItem("usuario")) return request;
  
  const datosUsuario = JSON.parse(window.sessionStorage.getItem("usuario"));
  
  if (request.url.includes("Login") && request.url.includes("Login/loginsso")) {
    request.headers["Authorization"] = "";
  } else {
    request.headers["Authorization"] = 'Bearer ' + datosUsuario.token;
  }
  return request;
}, error => Promise.reject(error));

// Interceptor de respuesta para manejar token expirado
axios.interceptors.response.use(
  response => response, // Si la respuesta es exitosa, simplemente la retorna
  error => {
    // Si hay un error 401 (No autorizado)
    if (error.response && error.response.status === 401) {
      // Obtener el token del sessionStorage
      const datosUsuario = window.sessionStorage.getItem("usuario");

      if (datosUsuario) {
        try {
          const usuario = JSON.parse(datosUsuario);
          const token = usuario.token;

          // Verificar si el token está expirado
          if (isTokenExpired(token)) {
            // Token expirado: ejecutar flujo completo de logout
            console.warn('Sesión expirada. Redirigiendo al login...');
            performLogout();
          } else {
            // Token válido pero 401: probablemente falta de permisos, no cerrar sesión
            console.warn('Error 401: Sin permisos para este recurso');
          }
        } catch (parseError) {
          // Error al parsear datos de usuario: ejecutar flujo completo de logout
          console.error('Error al parsear datos de usuario:', parseError);
          performLogout();
        }
      } else {
        // No hay sesión: redirigir al login
        window.location.href = '/';
      }
    }

    // Rechazar la promesa para que el error se propague
    return Promise.reject(error);
  }
);

// Función para validar que la URL es segura
const isUrlSafe = (url) => {
  // Permitir solo URLs relativas (no empiezan con http:// o https://)
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return true;
  }
  
  // Si es absoluta, debe coincidir con la base URL
  const baseUrl = process.env.REACT_APP_BASE_URL;
  return url.startsWith(baseUrl);
};

const requestGenerico = {
  get: (url, config = {}) => {
    if (!isUrlSafe(url)) throw new Error('URL no permitida');
    return axios.get(url, config);
  },
  post: (url, body, config = {}) => {
    if (!isUrlSafe(url)) throw new Error('URL no permitida');
    return axios.post(url, body, config);
  },
  put: (url, body, config = {}) => {
    if (!isUrlSafe(url)) throw new Error('URL no permitida');
    return axios.put(url, body, config);
  },
  delete: (url, config = {}) => {
    if (!isUrlSafe(url)) throw new Error('URL no permitida');
    return axios.delete(url, config);
  },
};

export default requestGenerico;